import { AI_CREATOR_APIs } from "@/modules/editor/request/api";
import { loginStore } from "@/modules/login/store";
import { ImgAndPromptItemType } from "@/stores/gallery";
import { MetaType } from "@/types/meta";
import { safeCall } from "@noli/core";

type OperationType = "download" | "generate_variation";
interface OperationData {
  download: {
    urls: (string | null | (string | null)[])[];
    metas: (MetaType | MetaType[])[];
  };
  generate_variation: {
    origin_img: ImgAndPromptItemType;
  };
}
export function postOperation<T extends OperationType>(type: T, data: OperationData[T]): void {
  safeCall(
    () =>
      fetch(`${process.env.REACT_APP_MAIN_URL}${AI_CREATOR_APIs.operateCreate}`, {
        method: "POST",
        headers: loginStore.jsonPostReqHeaders,
        body: JSON.stringify({ operate_type: type, operate_data: data }),
      }),
    {
      success: async () => void 0,
      failed: async (e) => console.error(`failed to postOperation: ${e}`),
    },
  );
}
